const check = async (to, from, next) => {
  if (to.query.token === 'a00981e1539234aa648b07c94196eb5b8bece497b41e816b02fbb906e8e5791758615be71dfcba89') {
    return next();
  }
  next('/');
};
const appGrabberRoutes = [
  {
    path: '/grabber/:supplierCode/:productId',
    name: 'grabber/index',
    component: () => import('@/portals/Grabber'),
    beforeEnter: check
  }
];
export { appGrabberRoutes as default };
